import React from 'react'
import'../css/team.css';
import TeamCard from '../components/TeamCard';
 function Team() {
  return (
    <div class="p-5" id="team" >
      
<div class=" d-flex justify-content-center" > 
<div  class="py-3 " >
<p class="fs-4 my-3 text-center" >Team Members </p>
<p class="fs-6 text-center "> This is our team of skilled  professionals</p>
</div>
 </div>
<div>
<div class="p-3 " > 
<div class="row"   >
  <div class="d-flex justify-content-center align-items-center col-sm-12 col-md-6 col-lg-4  p-3">
<TeamCard img="/assets/dhar.png" title="Senior Developer"  name="Muralidhar Kintada "/>
  </div>
  <div class=" d-flex justify-content-center align-items-center col-sm-12 col-md-6 col-lg-4  p-3 ">
<TeamCard img="/assets/melvin.png" title="Backend Developer"  name=" Melvin E Asisi "/>
  </div>
  <div class=" d-flex justify-content-center align-items-center col-sm-12 col-md-6 col-lg-4 p-3">
  <TeamCard img="/assets/bharat13.png" title=" React Developer"  name=" Bharat Petla"/>
  </div>
</div>
  </div>
</div>
</div>



    
    
  )
}
export default  Team;